import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import mqtt from 'mqtt';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Button,
} from '@mui/material';
import BackgroundImage from '../../components/BackgroundImage.js';
import AuditTrailViewService from '../../services/audittrailview.service.js';
import DashboardViewService from '../../services/dashboardview.service';


function isValidUrl(url) {
  try {
    new URL(url);
    return true;
  } catch (_) {
    return false;
  }
}


const Dashboard = () => {
  const { user } = useSelector((state) => state.auth);
  //const widgetName = useSelector((state) => state.splitbutton1.widgetName);
  const widgetName = useSelector((state) => state.splitbutton12WidgetName.widgetName);
  const widgetDescription = useSelector((state) => state.splitButton12WidgetDescription.widgetDescription);

  const [iframeLoaded, setIframeLoaded] = useState(true);

  const [dasboardConfig, setDashboardConfig] = useState ([])

  const [rowData, setRowData] = React.useState([]); // Specific Row Data

  const[remarkDialog, setRemarkDialog] = React.useState(false); // Remark Dialog bit
  const [eventDescription, setEventDescription] = useState("--");
  const [auditTrailRemark, setAuditTrailRemark] = useState("--");
  const [openRemarkBlnkMsg, setOpenRemarkBlnkMsg] = useState(false);
  const [password, setPassword] = useState('');
  const[pwdinterlock, setPwdInterlock] = useState("Disabled");

  
  // Get AuditTrail Configuration data for Remark field, either it is enabled or disabled
    useEffect(() =>{
      async function auditTrailConfigData()  {
      try {
  
        let dashboardName = 'AuditTrailConfig';
        let columnName = 'EventName';
        let columnValue = 'Delete Dashboard';
        let response = await AuditTrailViewService.getColumnData(dashboardName, columnName, columnValue);
  
        //console.log(response.data[0].EnableRemark);
        if(response.data.length > 0){
          setRowData({...rowData, EventStatus: response.data[0].EnableEvent, PWDInterlock: response.data[0].EnablePwdInterlock, RemarkStatus: response.data[0].EnableRemark});
          setPwdInterlock(response.data[0].EnablePwdInterlock);
          setEventDescription(response.data[0].DefaultEventDescription);
          // If remark field is disabled then set default remark vlaue to currrent Remark value
          if(response.data[0].EnableRemark === "Disabled"){
            setAuditTrailRemark(response.data[0].DefaultEventRemark);
          }
          
        }
  
      } catch (error) {
        console.log(error);
  
      }
    }
  
    auditTrailConfigData();
  
    }, []);

  //Get selecetd dasboard config data from Dashboardlist
  useEffect(() =>{
    async function getColumnData()  {
      try {
    
        let dashboardName = "DashboardList";
        let columnName = "WidgetName";
        let columnValue = widgetName;
        const response = await DashboardViewService.getColumnData(dashboardName, columnName, columnValue );
        //console.log(response.data);
        if(response.data.length > 0){
            setDashboardConfig(response.data[0]);
            //console.log(response.data[0])

            const weblink = response.data[0].DashboardWeblink;

            if (isValidUrl(weblink)) {
              //console.log("Valid weblink");
              setIframeLoaded(true);
            } else {
              //console.log("Invalid weblink");
              setIframeLoaded(false);
            }
            
        }
        
        
      } catch (error) {
        console.log(error);
    
      }
    }
    getColumnData();
      
  
  }, [widgetName]);


  // Send Dashboard Access at backend hence front end can access it and show contents accordingly
  useEffect(() =>{
    async function getColumnData()  {
      try {
        let currentUserRole = "visitor";
        if(user.role === "engineer" || user.role === "superadmin"){
          currentUserRole = "Admin"
        }else{
          currentUserRole = user.role
        }

        const isExportToPDFAccess = user && user.UserAccess && user.UserAccess[37] && user.UserAccess[37].Enable === "Enabled" && user.UserAccess[37].Options 
          ? user.UserAccess[37].Options.includes(currentUserRole)
          : false; // Default to false if user or the necessary properties are null or undefined

        const isExportToCSVAccess = user && user.UserAccess && user.UserAccess[38] && user.UserAccess[38].Enable === "Enabled" && user.UserAccess[38].Options 
          ? user.UserAccess[38].Options.includes(currentUserRole)
          : false; // Default to false if user or the necessary properties are null or undefined

        const isExportToJPGAccess = user && user.UserAccess && user.UserAccess[39] && user.UserAccess[39].Enable === "Enabled" && user.UserAccess[39].Options 
          ? user.UserAccess[39].Options.includes(currentUserRole)
          : false; // Default to false if user or the necessary properties are null or undefined

        const isConfigAccess = user && user.UserAccess && user.UserAccess[40] && user.UserAccess[40].Enable === "Enabled" && user.UserAccess[40].Options 
          ? user.UserAccess[40].Options.includes(currentUserRole)
          : false; // Default to false if user or the necessary properties are null or undefined

        const isLayoutConfigAccess = user && user.UserAccess && user.UserAccess[41] && user.UserAccess[41].Enable === "Enabled" && user.UserAccess[41].Options 
          ? user.UserAccess[41].Options.includes(currentUserRole)
          : false; // Default to false if user or the necessary properties are null or undefined

        const isSetpointAccess = user && user.UserAccess && user.UserAccess[42] && user.UserAccess[42].Enable === "Enabled" && user.UserAccess[42].Options 
          ? user.UserAccess[42].Options.includes(currentUserRole)
          : false; // Default to false if user or the necessary properties are null or undefined
          
    
        let dashboardName = "DashboardAccess";
        let dashboardAccessData = {
          ProjectName:user.ProjectName,
          DashboardType:user.DashboardType,
          DashboardName:widgetName,
          ExportToPDFAccess:user.UserAccess[37].Options,
          ExportToCSVAccess:user.UserAccess[38].Options,
          ExportToJPGAccess:user.UserAccess[39].Options,
          ConfigAccess:user.UserAccess[40].Options,
          LayoutConfigAccess:user.UserAccess[41].Options,
          SetpointAccess:user.UserAccess[42].Options,
          PWDInterlock:"Disabled",
          EventStatus: "Disabled",
        }

        let auditTrailData = {}
        

        const response = await DashboardViewService.updateDocument(dashboardName, dashboardAccessData, auditTrailData );
        //console.log(response.data);
        if(response.data.length > 0){
            setDashboardConfig(response.data[0]);
            //console.log(response.data)
            
        }
        
        
      } catch (error) {
        console.log(error);
    
      }
    }
    getColumnData();
      
  
  }, [widgetName]);


  // Dashboard box size calculation and applying it to the Box inside return statement
  const layoutOffset = 120; // e.g. height of your header/drawer in px
  const [boxHeight, setBoxHeight] = useState(window.innerHeight - layoutOffset);

  useEffect(() => {
    const handleResize = () => {
      setBoxHeight(window.innerHeight - layoutOffset);
    };

    handleResize(); // Initial calculation
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  

  //Send current logged user role to App B from this App A
  useEffect(() => {
    const iframe = document.getElementById('DashboardApp');
    let currentUserRole = "visitor";
    let currentUserEmail = user.email;
    let currentUserAccess = user.UserAccess;
    //console.log(currentUserAccess)
    //console.log(currentUserEmail )
    if(user.role === "engineer" || user.role === "superadmin"){
      currentUserRole = "engineer"
    }else{
      currentUserRole = user.role
    }

    if (!iframe) return;

    iframe.onload = () => {
    // Delay sending message to ensure App B is ready
    setTimeout(() => {
      //console.log(currentUserRole)
      //console.log(currentUserAccess)
      iframe.contentWindow.postMessage({ type: 'USER_ROLE', role: currentUserRole, email: currentUserEmail, UserAccess:currentUserAccess  },'*');
    }, 200); // 200ms delay is usually enough
};
  }, [user.role]);
  

  return (
    <Box
      sx={{
        height: `${boxHeight}px`,
        //overflow: 'auto',
        //border: '2px solid red',
      }}
    >
        {!iframeLoaded && <div><BackgroundImage/></div>}
        
        {iframeLoaded && (
          <iframe
            id="DashboardApp"
            //src="http://192.168.3.65:5173"
            src={dasboardConfig.DashboardWeblink}
            title="App2"
            style={{ width: '100%', height: '100%', border: 'none' }}
          />
        )}

    </Box>


  );
};

export default Dashboard;
